import { IDENTITY_TOKEN_VALIDATION_API_URL } from './apis';
import { redirectToLogin } from '../utils/login';
export const fetchIdentityUserToken = async (httpClient, errors) => {
  try {
    const {
      data: {
        hasIdentityToken
      }
    } = await httpClient.get(IDENTITY_TOKEN_VALIDATION_API_URL);
    if (!hasIdentityToken) {
      redirectToLogin();
      return;
    }
  } catch (e) {
    errors.push(e);
  }
};
//# sourceMappingURL=fetch-identity-user-token.js.map